
// export const LOGIN_BASE_URL = process.env.LOGIN_BASE_URL;
export const LOGIN_BASE_URL = "https://auth.mediadroppy.com";
// export const LOGIN_BASE_URL = "http://localhost:3000";
export const DEFAULT_REDIRECT_URI = "/";
export const UPLOAD_URL_V2 = "https://files.mediadroppy.com/v2/files";
export const BASE_URL = "https://files.mediadroppy.com/v2";
// export const UPLOAD_URL_V2 = "http://localhost:8080/v2/files";
// export const BASE_URL = "http://localhost:8080/v2";
// export const HOST_URL = "http://localhost:8080";
